import React, { FormEvent, useCallback, useEffect, useState } from 'react'
import { AdminLayout } from '../../../layout/AdminLayout'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import useApi from '../../../hooks/useApi'
import { useNavigate, useParams } from 'react-router-dom'
import { Diagnosis } from '../../../types/Diagnosis'
import { DiagnosisFields } from '../../../components/Diagnosis/DIagnosisFields'
import { HeaderPage } from '../../../components/HeaderPage'


export const DiagnosisForm = () => {

    const api = useApi()
    const navigate = useNavigate()
    const { id } = useParams<any>()

    const [diagnosis, setDiagnosis] = useState<Diagnosis | undefined>(undefined)

    const loadDiagnosis = useCallback(async () => {
        await api.get('/admin/diagnoses/' + id).then(res => {
            setDiagnosis(res.data)
        }).catch(console.log)
    }, [api, id])


    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        if (diagnosis) {
            data.append('_method', 'PATCH')
            return await api.post(`/admin/diagnoses/${diagnosis.id}`, data).then(res => {
                window.location.reload()
            }).catch(console.log)
        }

        await api.post("/admin/diagnoses", data).then(res => {
            navigate('/admin/testes')
        }).catch(console.log)

    }, [api, navigate, diagnosis])

    useEffect(() => {
        if (id)
            loadDiagnosis()
    }, [id, loadDiagnosis])

    return (
        <AdminLayout pageTitle='Testes'>
            <div className='grid grid-cols-6 mt-4'>
                <div className='py-5  pl-7 col-span-6'>
                   <HeaderPage name='Testes'/>
                </div>

                {!diagnosis ? <form onSubmit={handleSubmit} className='col-span-4 col-start-2  flex flex-col'>
                    <DiagnosisFields />
                    <div className='grid grid-cols-3 my-2'>
                        <SubmitButton className={'col-span-1'} value={'Salvar Teste'} />
                    </div>
                </form>
                    :
                    <div className='col-span-4 col-start-2  my-6 flex flex-col'>
                        <DiagnosisFields diagnosis={diagnosis} />
                    </div>
                }

            </div>
        </AdminLayout>
    )
}
